'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import ProductCard from './ProductCard';
import { Product } from '@/components/Product/ProductCard';

interface ProductListProps {
  isWeb: boolean;
  productsInfo?: Product[];
  handleProductClick: (index: number, item: Product) => void;
  handleProductValidInView: (index: number, item: Product) => void;
}

export function ProductList({
  isWeb,
  productsInfo = [],
  handleProductClick,
  handleProductValidInView,
}: ProductListProps) {
  if (isWeb) {
    return (
      <div className="relative h-full overflow-y-auto show-scrollbar-when-hover">
        <div className="relative grid grid-cols-2 gap-[12px]">
          {productsInfo.map((product, index) => (
            <ProductCard
              key={product.shop_sku}
              product={product}
              isWeb={isWeb}
              index={index}
              handleProductClick={handleProductClick}
              handleProductValidInView={handleProductValidInView}
            />
          ))}
        </div>
      </div>
    );
  }
  return (
    <Swiper className="h-[160px]" slidesPerView="auto" spaceBetween={8}>
      {productsInfo.map((product, index) => (
        <SwiperSlide key={product.shop_sku} className="!w-auto">
          <ProductCard
            product={product}
            isWeb={isWeb}
            index={index}
            handleProductClick={handleProductClick}
            handleProductValidInView={handleProductValidInView}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
